import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styles from "./Plano.module.css";
import EditModal from "./EditModal/EditModal";
import load from "../../../../../Images/loading.gif";

function Plano() {
    const { id } = useParams(); // ← pega o ID da URL
    const [plano, setPlano] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [loading, setLoading] = useState(true);

    const fetchPlan = async () => {
        try {
            const response = await fetch(`https://eclipsebots.com/api/planos/${id}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include"
            });

            if (!response.ok) {
                throw new Error("Failed to fetch plan");
            }

            const data = await response.json();
            setPlano(data[0]);
        } catch (error) {
            console.error("Erro ao buscar plano:", error);
            setPlano(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPlan();
    });

    const handleUpdatePlan = async (plan) => {
        await fetch("https://eclipsebots.com/api/planos/atualizar", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({ ...plan, id })
        });
        fetchPlan();
    };

    const handleDeletePlan = async () => {
        const confirmDelete = window.confirm("Tens a certeza que queres apagar este plano?");
        if (!confirmDelete) return;

        try {
            const response = await fetch(`https://eclipsebots.com/api/planos/delete/${id}`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: "include"
            });

            if (!response.ok) {
                throw new Error("Erro ao apagar plano");
            }

            fetchPlan();
        } catch (error) {
            console.error("Erro ao apagar plano:", error);
        }
    };

    const toggleIsEditing = async () => {
        setIsEditing(!isEditing);
    }


    if (loading) {
        return <div className={styles.content}>
            <div className={`${styles.size} ${styles.loading}`}>
                <img src={load} width="20px" height="20px" alt="loading" />
            </div>
        </div>
    }

    if (!plano) {
        return <div className={styles.noData}>Plano não encontrado.</div>;
    }

    return (
        <div className={styles.planos}>
            <EditModal isOpen={isEditing} plan={plano} onUpdate={handleUpdatePlan} onClose={() => setIsEditing(false)} />
            <div className={`${styles.plano} ${styles.first} ${styles.last}`}>
                <div className={styles.header}>
                    <div className={styles.image}>
                        <img
                            src={`${plano.image}`}
                            alt="Imagem do Plano"
                        />
                    </div>
                    <div className={`${styles.name} ${styles.imagem}`}>
                        <div>{plano.name}</div>
                        <div><span>{plano.description}</span></div>
                    </div>
                </div>
                <div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Descrição:</span><br /> {plano.points}
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Versão:</span><br /> {plano.version}
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Preço:</span> {plano.price}R$
                    </div>
                    <div className={styles.topic}>
                        <span className={styles.title}>Ciclo:</span> {plano.cycle}
                    </div>
                    <div className={`${styles.topic} ${styles.top}`}>
                        <span className={styles.title}>Status:</span> {!!plano.active === true ? "Ativo" : "Desativado"}
                    </div>
                    <div className={`${styles.topic} ${styles.bottom}`}>
                        <button onClick={() => toggleIsEditing()}>✏️ Editar</button>
                    </div>
                    <div className={`${styles.topic} ${styles.bottom}`}>
                        <button onClick={() => handleDeletePlan()}>🗑️ Apagar</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Plano;